import { Link } from 'react-router-dom';

export default function EmptyState({
  title,
  desc,
  actionTo = '/sites/new',
  actionText = '添加站点',
}: {
  title: string;
  desc: string;
  actionTo?: string;
  actionText?: string;
}) {
  return (
    <div className="rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="mx-auto w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
        <i className="ri-line-chart-line text-2xl" />
      </span>
      <h3 className="mt-5 font-heading text-xl font-semibold text-foreground-950">{title}</h3>
      <p className="mt-2 text-sm text-foreground-600 max-w-md mx-auto leading-relaxed">{desc}</p>
      <Link
        to={actionTo}
        className="inline-flex mt-6 px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md"
      >
        {actionText}
      </Link>
    </div>
  );
}
